import { render, staticRenderFns } from "./OrderCardDetail.vue?vue&type=template&id=4c6f8c5a&scoped=true"
import script from "./OrderCardDetail.vue?vue&type=script&lang=js"
export * from "./OrderCardDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderCardDetail.vue?vue&type=style&index=0&id=4c6f8c5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f8c5a",
  null
  
)

export default component.exports